import { render, staticRenderFns } from "./object-list-renderer.vue?vue&type=template&id=72f08b25&scoped=true&"
import script from "./object-list-renderer.vue?vue&type=script&lang=js&"
export * from "./object-list-renderer.vue?vue&type=script&lang=js&"
import style0 from "./object-list-renderer.vue?vue&type=style&index=0&id=72f08b25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f08b25",
  null
  
)

export default component.exports